var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"label-width":"80px"}},[_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("敬请期待")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }